var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgType(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "normal_size_full_screen_full_resize_fit_to_page_select_fit",
    "data-name": "normal size, full screen, full, resize, fit to page, select, fit",
    transform: "translate(-2 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_118",
    "data-name": "Path 118",
    d: "M40.571,2H3.429A1.429,1.429,0,0,0,2,3.429V40.571A1.429,1.429,0,0,0,3.429,42H40.571A1.429,1.429,0,0,0,42,40.571V3.429A1.429,1.429,0,0,0,40.571,2ZM39.143,39.143H4.857V4.857H39.143Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119",
    "data-name": "Path 119",
    d: "M20.429,8.857h5.714v5.714a1.429,1.429,0,1,0,2.857,0V7.429A1.429,1.429,0,0,0,27.571,6H20.429a1.429,1.429,0,1,0,0,2.857Z",
    transform: "translate(7.286 1.714)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_120",
    "data-name": "Path 120",
    d: "M7.429,29h7.143a1.429,1.429,0,1,0,0-2.857H8.857V20.429a1.429,1.429,0,1,0-2.857,0v7.143A1.429,1.429,0,0,0,7.429,29Z",
    transform: "translate(1.714 7.286)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_121",
    "data-name": "Path 121",
    d: "M7.429,16a1.429,1.429,0,0,0,1.429-1.429V8.857h5.714a1.429,1.429,0,0,0,0-2.857H7.429A1.429,1.429,0,0,0,6,7.429v7.143A1.429,1.429,0,0,0,7.429,16Z",
    transform: "translate(1.714 1.714)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122",
    "data-name": "Path 122",
    d: "M20.429,29h7.143A1.429,1.429,0,0,0,29,27.571V20.429a1.429,1.429,0,1,0-2.857,0v5.714H20.429a1.429,1.429,0,1,0,0,2.857Z",
    transform: "translate(7.286 7.286)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgType);
export default __webpack_public_path__ + "static/media/type.dca8dd4c99fc4027d615dffb3ef139f6.svg";
export { ForwardRef as ReactComponent };